var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-ai"},[_c('iframe',{staticStyle:{"margin-top":"-54px"},attrs:{"src":_vm.url,"width":"100%","height":"100%","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }